import { createFileRoute } from "@tanstack/react-router";
import { ScheduleEnrollmentsList } from "./-components/ScheduleEnrollmentsList";

export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/schedules/$scheduleId/enrollments",
)({
	component: ScheduleEnrollmentsPage,
});

function ScheduleEnrollmentsPage() {
	const { orgId, scheduleId } = Route.useParams();

	return (
		<ScheduleEnrollmentsList organizationId={orgId} scheduleId={scheduleId} />
	);
}
